<template>
  <v-expansion-panels
      v-model="panels"
      :multiple="searchIsActive"
      accordion
      flat
      class="expansion-panel"
      :class="{'justify-start': sortedInternalOrders.length == 0}"
  >
    <!--  the key needs to be a combination of id and index to ensure the component is destoryed/created after sorting-->
    <OrderExpansionPanel
        v-for="(orderConfig, index) in sortedInternalOrders"
        :key="orderConfig.id+'-'+index"
        :orderConfig="orderConfig"
        :index="index"
    />
    <div class="mt-4" v-if="!internalOrdersLoading && sortedInternalOrders.length == 0">
      Keine Komissionieraufträge vorhanden
    </div>
    <div class="mt-4" v-if="internalOrdersLoading">
      <v-progress-circular
          color="primary"
          indeterminate
      />
    </div>

  </v-expansion-panels>
</template>

<script>
import OrderExpansionPanel from "@/components/SmartLogistics/Warehouse/Order/OrderExpansionPanel.vue";
import {mapGetters} from "vuex";
import Loader from "@/components/layout/Loader.vue";

export default {
  name: 'Commissioning',
  components: {Loader, OrderExpansionPanel},

  data() {
    return {}
  },

  computed: {
    ...mapGetters({
      isMobile: 'system/isMobile',
      searchIsActive: 'smartLogisticSettings/searchIsActive',
      internalOrders: 'smartLogisticWarehouse/internalOrders',
      selectedSortingType: 'smartLogisticWarehouse/selectedSortingType',
      selectedStatus: 'smartLogisticWarehouse/selectedStatus',
      selectedDates: 'smartLogisticWarehouse/selectedDates',
      config: 'smartLogisticWarehouse/config',
    }),

    internalOrdersLoading() {
      return this.$store.getters['smartLogisticWarehouse/isLoading']('fetchInternalOrders')
    },

    panels: {
      get() {
        this.$store.getters['smartLogisticWarehouse/activePanels']
      },
      set(value) {
        this.$store.commit('smartLogisticWarehouse/setPanels', value)
      }
    },

    sortedInternalOrders() {
      this.loading = true
      let internalOrders = this.internalOrders;

      if (this.selectedStatus.length > 0) {
        internalOrders = internalOrders.filter(o => this.selectedStatus.includes(o.status))
      }

      if (this.selectedSortingType === 'livingUnit') {
        return internalOrders.sort((a, b) => {
          const nameDiff = a.living_unit_name.localeCompare(b.living_unit_name)

          if (nameDiff !== 0) {
            return nameDiff
          }

          internalOrders = this.config.statusOrderTypes.findIndex(s => s.value === a.status) - this.config.statusOrderTypes.findIndex(s => s.value === b.status)
        })
      } else if (this.selectedSortingType === 'status') {
        return internalOrders.sort((a, b) => {
          const statusDiff = this.config.statusOrderTypes.findIndex(s => s.value === a.status) - this.config.statusOrderTypes.findIndex(s => s.value === b.status)

          if (statusDiff !== 0) {
            return statusDiff
          }

          internalOrders = a.living_unit_name.localeCompare(b.living_unit_name)
        });
      } else {
        internalOrders = internalOrders.sort((a, b) => {
          let dateA = new Date(a.date* 1000);
          let dateB = new Date(b.date* 1000);
          return dateB - dateA
        })
      }
      return internalOrders
    }
  },

  watch: {
    selectedDates() {
      this.$store.dispatch('smartLogisticWarehouse/fetchInternalOrders', true)
    }
  },

  mounted() {
    this.$store.dispatch('smartLogisticWarehouse/fetchInternalOrders', true)
  }
}
</script>
